"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextProvider = void 0;
var react_1 = __importStar(require("react"));
var userContext_1 = require("./userContext");
exports.UserContextProvider = function (props) {
    var _a = react_1.useState(new userContext_1.User({}, props.config)), user = _a[0], setUser = _a[1];
    var _b = react_1.useState(), token = _b[0], setToken = _b[1];
    var _c = react_1.useState(), promotion = _c[0], setPromotion = _c[1];
    var _d = react_1.useState(''), language = _d[0], setLanguage = _d[1];
    var _e = react_1.useState(''), currency = _e[0], setCurrency = _e[1];
    var _f = react_1.useState(''), customerId = _f[0], setCustomerId = _f[1];
    var _g = react_1.useState(''), countryCode = _g[0], setCountryCode = _g[1];
    var _h = react_1.useState(''), regionCode = _h[0], setRegionCode = _h[1];
    var _j = react_1.useState(''), timeZone = _j[0], setTimeZone = _j[1];
    var contextConfig = react_1.useState(props.config)[0];
    var clearToken = function () { return setToken(undefined); };
    var setPlayerData = react_1.useCallback(function (token, promotion) {
        setToken(token);
        setPromotion(promotion);
    }, [setToken, setPromotion]);
    react_1.useEffect(function () {
        var params = {
            token: token,
            promotion: promotion,
            language: language,
            countryCode: countryCode,
            regionCode: regionCode,
            timeZone: timeZone,
            currency: currency,
            customerId: customerId
        };
        setUser(new userContext_1.User(params, contextConfig, props.languageManager));
    }, [token, promotion, customerId, language, countryCode, regionCode, currency, contextConfig, props.languageManager]);
    return (react_1.default.createElement(userContext_1.UserContext.Provider, { value: { user: user, setToken: setToken, clearToken: clearToken, setPlayerData: setPlayerData, setLanguage: setLanguage, setCurrency: setCurrency, setCustomerId: setCustomerId, setCountryCode: setCountryCode, setRegionCode: setRegionCode, setTimeZone: setTimeZone } }, props.children));
};
